import React from "react";
import { DailyCollectionReportContent } from '../../../Common/Table/tableContent';
import tokenService from '../../../../Common/tokenDecoder';

export default class ComponentToPrint extends React.Component {
    render() {

        const searchData = this.props.searchData;
        const resultData = this.props.data;
        const contentRowNames = this.props.rowNames;
        const permission = this.props.permission;
        const feildAvailabeDedauctionTypes = this.props.feildAvailabeDedauctionTypes;
        const weighDedauctionTypesTable = this.props.weighDedauctionTypesTable;
        const weighAvailabeDedauctionTypes = this.props.weighAvailabeDedauctionTypes;
        const totalSummaryRow = this.props.totalSummaryRow;

        function generateTotalRow(mobileSessionID) {

            var result = totalSummaryRow.find(x => x.mobileSessionID === mobileSessionID);

            var tempRes = [];

            contentRowNames.forEach((x, i) => {
                if (i > 6) {
                    for (var prop in result) {
                        if (prop === x) {
                            tempRes.push({ name: prop, value: result[prop] });
                        }
                    }
                }
            });

            if (result) {
                return (
                    <tr>
                        <th colSpan="7">Total</th>
                        {
                            tempRes.map((x, i) => {
                                if (x.name === "lossGain") {
                                    return (<th key={i}></th>)
                                } else {
                                    return (<th key={i} style={{ textAlign: "right" }}>{x.value.toFixed(2)}</th>)
                                }
                            })
                        }
                    </tr>
                );
            }
        }

        return (
            <div>
                <h3 className="pr-2"><center><u>Daily Collection Detailed Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Route: </b> {searchData.route}</div>
                    <div className="col"><b>Factory: </b> {searchData.factory}</div>
                    <div className="col"><b>From Date: </b> {searchData.date}</div>
                    <div className="col"><b>To Date: </b> {searchData.toDate}</div>
                </div>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Current Date: </b> {new Date().toLocaleString()}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                </div>
                {resultData.map((e, index) => {
                    return (
                        <div className="pt-2 pl-2 pr-2 pb-3" key={index}>
                            <p><b>Session start date: {e[0].sessionStartDate}</b></p>
                            <p><b>Session start time: {e[0].sessionStartTime}</b></p>
                            <table
                                id={e[0].mobileSessionID + "_Pdf"}
                                className="display dataTable">
                                <thead>
                                    <tr>
                                        <th style={{ fontSize: "12px" }} rowSpan="2">Customer Name</th>
                                        <th style={{ fontSize: "12px" }} rowSpan="2">Date</th>
                                        <th style={{ fontSize: "12px" }} rowSpan="2">Time</th>
                                        <th style={{ fontSize: "12px" }} rowSpan="2">Collection Type</th>
                                        <th style={{ fontSize: "12px" }} rowSpan="2">Tag Number</th>
                                        <th style={{ fontSize: "12px" }} rowSpan="2">Registration Number</th>
                                        <th style={{ fontSize: "12px" }} rowSpan="2">Narration</th>
                                        <th style={{ fontSize: "12px" }} colSpan={feildAvailabeDedauctionTypes.length + 3} scope="colgroup">Field</th>
                                        <th style={{ fontSize: "12px" }} colSpan={weighAvailabeDedauctionTypes.length + 3} scope="colgroup">Factory Weigh</th>
                                        <th style={{ fontSize: "12px" }} rowSpan="2">Gross Variance (Kg)</th>
                                        <th style={{ fontSize: "12px" }} rowSpan="2">Loss/Gain</th>
                                    </tr>
                                    <tr>
                                        <th style={{ fontSize: "12px" }} scope="col">Actual Amount (Kg)</th>
                                        <th style={{ fontSize: "12px" }} scope="col">Gross Amount (Kg)</th>
                                        {feildAvailabeDedauctionTypes.map((data, index) => {
                                            return (
                                                <th style={{ fontSize: "12px" }} scope="col" key={index}>{data}</th>
                                            );
                                        })}
                                        <th style={{ fontSize: "12px" }} scope="col">Net Amount (Kg)</th>
                                        <th style={{ fontSize: "12px" }} scope="col">Actual Amount (Kg)</th>
                                        <th style={{ fontSize: "12px" }} scope="col">Gross Amount (Kg)</th>
                                        {weighDedauctionTypesTable.map((data, index) => {
                                            return (
                                                <th style={{ fontSize: "12px" }} scope="col" key={index}>{data}</th>
                                            );
                                        })}
                                        <th style={{ fontSize: "12px" }} scope="col">Net Amount (Kg)</th>
                                        {
                                            permission.isVarianceColumnEnabled ?
                                                <th style={{ fontSize: "12px" }} scope="col">Variance (Kg)</th> : null
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    <DailyCollectionReportContent
                                        data={e}
                                        contentRowNames={contentRowNames}
                                        hasEdit={false}
                                    />
                                </tbody>
                                <tfoot>
                                    {generateTotalRow(e[0].mobileSessionID)}
                                </tfoot>
                            </table>
                        </div>
                    )
                })}
            </div>
        );
    }
}